import { Directive, ElementRef, HostListener, OnInit } from '@angular/core';
import { MatSelect } from '@angular/material/select';
import { OverlayContainer}  from '@angular/cdk/overlay';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'mat-select',
    standalone: false
})
export class  MultiSelectDirective implements OnInit {

  overlayPane: Element;

  constructor(private select: MatSelect, private elementRef: ElementRef, private overlayContainer: OverlayContainer) {
  }

  @HostListener('click') onClick(): void {
    this.overlayPane = this.getOverlayPane();
    this.overlayPane?.classList.add('multi-select-panel');
    this.getMatSelectPanel()?.setAttribute('max-width', `${this.getElementWidth()}px !important`);
  }

  ngOnInit(): void {
    this.select.openedChange.subscribe(isOpen => {
      if(!isOpen) {
        this.overlayPane?.classList.remove('multi-select-panel');
      }
    });
  }

  /**
   * Finds and returns the overlay pane element
   *
   * @returns the overlay pane element
   */
  private getOverlayPane(): Element {
    return this.overlayContainer
               .getContainerElement()
               .getElementsByClassName('cdk-overlay-pane')
               .item(0);
  }

  /**
   * Finds and returns the mat select panel element
   *
   * @returns the mat select panel element
   */
  private getMatSelectPanel(): Element {
    return this.overlayPane?.getElementsByClassName('mat-select-panel').item(0);
  }

  /**
   * Prepares and returns the width of the current element
   *
   * @returns - the width of the current element
   */
  private getElementWidth(): number {
    return this.elementRef.nativeElement.offsetWidth;
  }
}
